var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { css as emotionCss } from 'emotion';
import { gridItem } from '../styles/citron';
export var GridItem = function (_a) {
    var _b = _a.breakpointPhone, breakpointPhone = _b === void 0 ? 700 : _b, _c = _a.breakpointTabletPortrait, breakpointTabletPortrait = _c === void 0 ? 860 : _c, children = _a.children, column = _a.column, row = _a.row, otherMediaQueries = _a.otherMediaQueries, phoneColumn = _a.phoneColumn, phoneRow = _a.phoneRow, tabletColumn = _a.tabletColumn, tabletRow = _a.tabletRow;
    var getValue = function (item) { return (item === 'full' ? '1 / -1' : item); };
    var css = gridItem({
        breakpointPhone: breakpointPhone,
        breakpointTabletPortrait: breakpointTabletPortrait,
        column: getValue(column),
        row: getValue(row),
        phoneColumn: getValue(phoneColumn),
        phoneRow: getValue(phoneRow),
        tabletColumn: getValue(tabletColumn),
        tabletRow: getValue(tabletRow),
    });
    return React.createElement("div", { className: emotionCss(__assign(__assign({}, css), otherMediaQueries)) }, children);
};
